import { render } from "./searchUserResult.vue?vue&type=template&id=01044e2c"
import script from "./searchUserResult.vue?vue&type=script&lang=js"
export * from "./searchUserResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__